import { Component, inject, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  WarehouseSensorAddComponent
} from "../../warehouses-list/warehouse-view/warehouse-sensor-list/warehouse-sensor-add/warehouse-sensor-add.component";

interface Warehouses {
  name: string;
  region: string;
  buildings: number;
}
@Component({
  selector: "app-warehouses-modal",
  templateUrl: "./warehouses-modal.component.html",
  styleUrl: "./warehouses-modal.component.scss",
})
export class WarehousesModalComponent implements OnInit {
  private dialogRef: MatDialogRef<WarehouseSensorAddComponent> = inject(
    MatDialogRef<WarehouseSensorAddComponent>
  );

  public columns;
  public tableData: Warehouses[];
  title: string;
  loading: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) data) {}

  ngOnInit() {
    this.title = "Warehouses";
    this.columns = {
      name: "Name",
      region: "Regional zone",
      buildings: "Buildings",
    };
    this.tableData = [
      {
        name: "Warehouse A",
        region: "Dodoma",
        buildings: 4,
      },
      {
        name: "Warehouse A",
        region: "Dodoma",
        buildings: 4,
      },
      {
        name: "Warehouse A",
        region: "Dodoma",
        buildings: 4,
      },
      {
        name: "Warehouse A",
        region: "Dodoma",
        buildings: 4,
      },
    ]
  }

  closeModal() {
    this.dialogRef.close();
  }
}
